import React from 'react'

export default function Lodeing() {
  return (
    <div>
      <div className="loader">
  <div className="justify-content-center jimu-primary-loading"></div>
</div>
    </div>
  )
}
